import type { CollapsedBelow } from '@magicschool/spellbook/components/CollapsibleButtonGroup';
import { DropdownMenu } from '@magicschool/spellbook/components/DropdownMenu';
import type { IconProps } from '@magicschool/spellbook/components/Icon';
import type { BreakpointKey } from '@magicschool/spellbook/hooks/useBreakpoint';

export function isContainerBreakpoint(value: CollapsedBelow): value is `@${BreakpointKey}` {
  return value.startsWith('@');
}

/**
 * Icon + label content shared by a collapsed action's menu item and its submenu trigger. A plain function
 * (not a component) so the `Fragment` it returns is a literal child when called inline — `DropdownMenu.Item`
 * and `DropdownMenu.SubTrigger` detect their `ItemLeadingIcon`/`ItemLabel` slots by scanning their own
 * `children` prop before anything renders, and only unwrap a literal `Fragment` there, not a custom
 * component's eventual output. Passing `<SomeComponent/>` instead would silently skip real slot placement.
 */
export function collapsedActionContent(icon: IconProps['name'] | undefined, label: string) {
  return (
    <>
      {icon && <DropdownMenu.ItemLeadingIcon name={icon} />}
      <DropdownMenu.ItemLabel>{label}</DropdownMenu.ItemLabel>
    </>
  );
}
